import { useState } from "preact/hooks";
import { ACCENTS } from "../demo-v2/accents.js";
import { demoHref } from "../demo-v2/prefill.js";
import type { AccentId } from "../demo-v2/types.js";
import { BrandScene } from "./brand-scene.js";
import type { FlowCopy, StudioCopy, WallCopy } from "./content.js";
import { MenuIcon } from "./icons.js";

export interface StudioProps {
  readonly copy: StudioCopy;
  readonly flow: FlowCopy;
  readonly wall: WallCopy;
}

export function Studio({ copy, flow, wall }: StudioProps) {
  const [name, setName] = useState(copy.names[0] ?? "");
  const [accent, setAccent] = useState<AccentId>("green");
  return (
    <section class="section studio launch" id="marca">
      <div class="wrap studio-grid">
        <div class="studio-text">
          <p class="micro">{copy.label}</p>
          <h2 class="section-title serif">{copy.title}</h2>
          <p class="split-body">{copy.body}</p>
        </div>
        <div class="studio-controls">
          <p class="micro" id="studio-name">
            {copy.nameLabel}
          </p>
          <div class="studio-names" role="group" aria-labelledby="studio-name">
            {copy.names.map((option) => (
              <button
                key={option}
                type="button"
                class={option === name ? "chip is-selected" : "chip"}
                aria-pressed={option === name}
                onClick={() => setName(option)}
              >
                {option}
              </button>
            ))}
          </div>
          <p class="micro" id="studio-color">
            {copy.colorLabel}
          </p>
          <div class="studio-colors" role="group" aria-labelledby="studio-color">
            {ACCENTS.map((option) => (
              <button
                key={option.id}
                type="button"
                class={option.id === accent ? "swatch is-on" : "swatch"}
                style={{ "--swatch": option.hex }}
                aria-label={copy.colorNames[option.id]}
                aria-pressed={option.id === accent}
                onClick={() => setAccent(option.id)}
              />
            ))}
            <span class="studio-color-name">{copy.colorNames[accent]}</span>
          </div>
        </div>
        <div class="launch-actions">
          <a
            class="pill pill-line launch-cta"
            href={demoHref(name, accent)}
            data-testid="studio-demo"
          >
            {copy.demo.cta}
            <MenuIcon name="arrow" size={16} />
          </a>
          <p class="launch-note">{copy.demo.note}</p>
          <div class="launch-qr">
            <img src="/assets/demo/qr.svg" alt="" width={88} height={88} loading="lazy" />
            <div>
              <strong>{copy.demo.qrTitle}</strong>
              <span>{copy.demo.qrBody}</span>
            </div>
          </div>
        </div>
        <BrandScene name={name} accent={accent} flow={flow} wall={wall} />
      </div>
    </section>
  );
}
